import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import type { Action } from 'redux';
import {
  reportMissingClosingTotalFilteredStoresSelector,
  reportFilterStoresSelector,
} from '../state';
import type { Stores } from '../types';

const NO_OP_ACTION = { type: 'NO_STORES_AFTER_OP_STRUCTURE_FILTER' };

const useOpStructureValidation = () => {
  const storesForCompany = useSelector(reportMissingClosingTotalFilteredStoresSelector);
  const storesSelected = useSelector(reportFilterStoresSelector);

  const validateAndExecuteAction = useCallback(
    (actionToExecute: (stores: Stores[]) => Action) => {
      if (
        (!storesForCompany || storesForCompany.length === 0) &&
        (!storesSelected || storesSelected.length === 0)
      ) {
        return NO_OP_ACTION;
      }

      return actionToExecute(storesForCompany);
    },
    [storesForCompany, storesSelected]
  );

  return validateAndExecuteAction;
};

export default useOpStructureValidation;
